import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 50 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "25",
      cy: "25",
      r: "24.456",
      fill: "#FCFEFF",
      stroke: "#83B9FF",
      "stroke-dasharray": "4.35 4.35",
      "stroke-width": "1.087"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M32 22c0 1.45-.43 2.78-1.17 3.89a6.99 6.99 0 0 1-4.78 3.02Q25.54 29 25 29t-1.05-.09a6.99 6.99 0 0 1-4.78-3.02A6.97 6.97 0 0 1 18 22c0-3.87 3.13-7 7-7s7 3.13 7 7",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "m34.25 31.47-1.65.39c-.37.09-.66.37-.74.74l-.35 1.47a1 1 0 0 1-1.74.41L25 29l-4.77 5.49a1 1 0 0 1-1.74-.41l-.35-1.47a1 1 0 0 0-.74-.74l-1.65-.39a1.003 1.003 0 0 1-.48-1.68l3.9-3.9a6.99 6.99 0 0 0 4.78 3.02q.51.09 1.05.09t1.05-.09c1.99-.29 3.7-1.42 4.78-3.02l3.9 3.9c.55.54.28 1.49-.48 1.67m-8.67-12.49.59 1.18c.08.16.29.32.48.35l1.07.18c.68.11.84.61.35 1.1l-.83.83c-.14.14-.22.41-.17.61l.24 1.03c.19.81-.24 1.13-.96.7l-1-.59a.7.7 0 0 0-.66 0l-1 .59c-.72.42-1.15.11-.96-.7l.24-1.03c.04-.19-.03-.47-.17-.61l-.83-.83c-.49-.49-.33-.98.35-1.1l1.07-.18c.18-.03.39-.19.47-.35l.59-1.18c.29-.64.81-.64 1.13 0"
    }, null, -1)
  ]))]))
}
export default { render: render }